export default class Cell {
    constructor(row, column, value = 0) {
        this.row = row;
        this.column = column;
        this._value = value;
    }

    set value(value) {
        this._value = value;
    }

    get value() {
        return this._value;
    }

    increment() {
        this._value =  (this._value + 1) % 3;
    }
}